import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo, forwardRef } from 'react';
import { capitalize } from 'validate.js';

import Tabs from 'dpl/common/design_system/Tabs';
import { RESULTS_TYPES } from 'dpl/puppy_search_results/utils/constants';
import useSearchFiltering from 'dpl/search_result_filters/hooks/useSearchFiltering';

const RESULTS_TYPE_TAB_INDICES = {
  0: RESULTS_TYPES.BREEDERS,
  1: RESULTS_TYPES.PUPPIES
};

const TAB_VALUES = Object.values(RESULTS_TYPE_TAB_INDICES);
const TAB_ITEMS = TAB_VALUES.map(capitalize);

const ResultsTypeSelector = forwardRef(
  /** @param {any} props */ function ResultsTypeSelector(
    { className = null, tabClassName = null, disabled = false },
    ref
  ) {
    const { resultsType, setResultsType } = useSearchFiltering();

    const initialTabIndex = useMemo(
      () => TAB_VALUES.indexOf(resultsType),
      [resultsType]
    );

    function handleTabClick(tabIndex) {
      setResultsType(RESULTS_TYPE_TAB_INDICES[tabIndex]);
    }

    return (
      <Tabs
        ref={ref}
        classes={{
          root: classnames('ResultsTypeSelector', className),
          list: 'gap-20',
          item: 'w-100 w-auto-ns',
          tab: classnames(
            'ResultsTypeSelector__tab justify-center font-16 md:font-18 fw-medium w-100 pv3 pv2-md',
            tabClassName
          ),
          activeTab: 'ResultsTypeSelector__tab--active black',
          inactiveTab: 'tertiary',
          glider: 'bb b--black'
        }}
        activeTabIndex={initialTabIndex}
        tabItems={TAB_ITEMS}
        onTabClick={handleTabClick}
        disabled={disabled}
      />
    );
  }
);

ResultsTypeSelector.propTypes = {
  className: PropTypes.string,
  tabClassName: PropTypes.string,
  disabled: PropTypes.bool
};

export default ResultsTypeSelector;
